<div class="col fo-p is-hidden-mobile">
  <div class="">
    <div class="list-wrapper py-2">
      <h3 class="list-collapse" ng-click="single = !single">
        Users
        <!-- <i class="fa fa-angle-down is-pulled-right">Real time updates</i> -->
        <span (click)="showRealTimeUpdate()" class="is-pulled-right"
          ><i class="pi pi-times"></i
        ></span>
      </h3>

      <div>
        <!-- <figure><img [src]="'../../../assets/images/app-ui-sample-graph.png'" /></figure> -->
        <!-- <figure>
        <canvas baseChart
          [datasets]="barChartData"
          [labels]="barChartLabels"
          [chartType]="barChartType"
          [options]="barChartOptions"
          [legend]="barChartLegend"
          (chartHover)="chartHovered($event)"
        (chartClick)="chartClicked($event)"></canvas>
      </figure> -->
        <!-- <hr /> -->

        <!-- <div class="has-text-centered">
      <button class="button is-small is-link is-outlined" (click)="moreInfo()">More Info</button>
    </div> -->

        <!-- <div class="menu-options level is-marginless display-flex">
    <div class="level-left">
      Users
    </div>
    <div class="level-right">
      <div class="level-item">
        <a class="is-small" title="Add Members">
          <i class="pi pi-user"></i>
        </a>
      </div>
    </div>
  </div> -->

        @if (showMoreInfo) {
        <ul class="scroll-bar user-info-list">
          @for (user of postUserList; track user) {
          <li class="cursor-pointer pos-relative">
            <div class="columns is-gapless">
              <div class="column is-one-quarter">
                @if (!user.user_icon) {
                <empty-uname
                  [userName]="user.full_name"
                  [liProfile]="true"
                ></empty-uname>
                } @if (user.user_icon) {
                <img [src]="profileUrl + user.user_icon" />
                }
              </div>
              <div
                class="column is-clearfix pos-relative d-flex align-items-center"
              >
                <div class="is-pulled-left">
                  <label class="is-size-6"
                    >{{ user.full_name }}
                    <br />
                    <span class="is-size-7">{{
                      user.last_seen | amTimeAgo
                    }}</span>
                  </label>
                </div>
              </div>
            </div>
            <!-- <div class="chat-close">
            <i class="fa fa-check"></i>
          </div>
          <div class="chat-check" *ngIf="selectedUserIdList.indexOf(user.user_id) > -1">
            <i class="fa fa-check"></i>
          </div> -->
          </li>
          }
          <!-- <li class="cursor-pointer">
      <div class="columns is-gapless ">
        <div class="column is-one-quarter group-img">
          <img [src]="'../../../assets/images/avatar-2.jpg'" class="img-2">
        </div>
        <div class="column is-clearfix">
          <div class="level">
            <div class="level-left">
              <label class="is-size-5">John kin
                <span class="is-size-7 display-b">Health group</span>
              </label>
            </div>
            <div class="level-right">
              <div class="level-item display-b">
                <span class="notfic-resend-btn">
                  <i class="fa fa-check delivered yellow" title="Delivered"></i> |
                  <i class="fa fa-paper-plane" title="Resend" style="font-size: 13px; padding-top: 5px;"></i>
                </span>
                <br>
                  <span class="tag is-small" title="Delivered on">10 hrs ago</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li> -->
          <!-- <li class="cursor-pointer">
      <div class="columns is-gapless ">
        <div class="column is-one-quarter group-img">
          <img [src]="'../../../assets/images/128%20(1).jpg'" class="img-2">
        </div>
        <div class="column is-clearfix">
          <div class="level">
            <div class="level-left">
              <label class="is-size-5">Sam
                <span class="is-size-7 display-b">Dev group</span>
              </label>
            </div>
            <div class="level-right">
              <div class="level-item display-b">
                <span class="notfic-resend-btn">
                  <i class="fa fa-check delivered yellow" aria-hidden="true" title="Delivered"></i> |
                  <i class="fa fa-paper-plane" aria-hidden="true" title="Resend" style="font-size: 13px; padding-top: 5px;"></i>
                </span>
                <br>
                  <span class="tag is-small" title="Delivered on">10 hrs ago</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li> -->
          <!--   -->
        </ul>
        }
      </div>

      <!-- <h3 class="list-collapse">Activity stream
<i class="fa fa-angle-down is-pulled-right"></i>
</h3>
<ul class="timeline">
  <li class="cursor-pointer">
    <span class="circle-spot"></span>
    <h3>Aug 18, 10:00am</h3>
    <p>-
      <small>Message delivered to sam, John kin, Tom</small>
    </p>
  </li>
  <li class="cursor-pointer">
    <span class="circle-spot"></span>
    <h3>Aug 18, 10:02am</h3>
    <p>-
      <small>Message viewed by sam and Tom</small>
    </p>
  </li>
  <li class="cursor-pointer">
    <span class="circle-spot"></span>
    <h3>Aug 18, 15:13pm</h3>
    <p>-
      <small>Admin updated the status</small>
    </p>
  </li>
  <li class="cursor-pointer">
    <span class="circle-spot"></span>
    <h3>Aug 18, 15:45pm</h3>
    <p>-
      <small>Sam posted the comment</small>
    </p>
  </li>
</ul> -->

      <!-- <h3 class="list-collapse" ng-click="poll = !poll">Poll Result
<i class="fa fa-angle-down is-pulled-right"></i>
</h3>
<div ng-class="{'display-n' : poll}" style="padding: 0 10px;">
  <p>
    <strong>Q: </strong>Please let me know if you can access email ?</p>
    <table class="table is-bordered is-striped is-narrow is-fullwidth">
      <thead>
        <tr>
          <th>User</th>
          <th>Yes</th>
          <th>No</th>
          <th>No Reply</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Sam</td>
          <td class="has-text-centered">
            <i class="fa fa-check" aria-hidden="true"></i>
          </td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Tom curise</td>
          <td></td>
          <td class="has-text-centered">
            <i class="fa fa-check" aria-hidden="true"></i>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>John kin </td>
          <td></td>
          <td></td>
          <td class="has-text-centered">
            <i class="fa fa-check" aria-hidden="true"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div> -->
    </div>
  </div>
</div>
